import React, { useContext } from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { useDealer } from '@/hooks/Dealer'
import { UserStoreContext } from '@/stores/UserStore'

import { DealerHeader } from './DealerHeader'

const DealerLayout = () => {
  const { id } = useParams()
  const { isDealerUser, isDealerAdmin } = useContext(UserStoreContext)
  const isROServiceUser = isDealerUser && !isDealerAdmin

  // Shared with the Dashboard and Log ROs, so moving between them keeps the header.
  const { dealer, error } = useDealer(id)

  return (
    <>
      {!error && <DealerHeader dealer={dealer} isROServiceUser={isROServiceUser} />}

      <Outlet context={{ dealer, error }} />
    </>
  )
}

export default DealerLayout
